import React from 'react';
import { Helmet } from 'react-helmet-async';

const TermsConditions = () => {
  return (
    <div>
      <Helmet>
        <title>Terms & Conditions - Global Trademark Pro</title>
        <meta name="description" content="Read Global Trademark Pro's terms and conditions for using our trademark registration and brand protection services." />
        <link rel="canonical" href="https://yourdomain.com/terms-conditions" />
      </Helmet>
      <section className="bg-gradient-to-br from-emerald-50 via-white to-blue-50 py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
              Terms & Conditions
            </h1>
            <p className="text-lg text-gray-600">
              Last updated: January 2025
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto space-y-8">
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">1. Acceptance of Terms</h2>
              <p className="text-gray-700 leading-relaxed">
                By accessing and using Global Trademark Pro's services, you accept and agree to be bound by these Terms and Conditions. If you do not agree to these terms, please do not use our services.
              </p>
            </div>

            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">2. Services Description</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Global Trademark Pro provides trademark registration consulting services, including but not limited to:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                <li>Trademark application preparation and filing with the USPTO</li>
                <li>Trademark search and availability analysis</li>
                <li>Copyright registration services</li>
                <li>Company formation assistance</li>
                <li>Amazon Brand Registry enrollment</li>
                <li>Trademark monitoring and maintenance support</li>
              </ul>
            </div>

            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">3. Service Fees and Payment</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                All service fees are listed on our website and are subject to change without notice. Payment terms include:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                <li>Service fees are separate from government filing fees</li>
                <li>Payment is required before service commencement</li>
                <li>Government fees are non-refundable once submitted to the USPTO</li>
                <li>All fees are in US Dollars unless otherwise stated</li>
              </ul>
            </div>

            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">4. Client Responsibilities</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                As a client, you agree to:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                <li>Provide accurate and complete information for your trademark application</li>
                <li>Respond promptly to requests for information or clarification</li>
                <li>Review all documents before submission to the USPTO</li>
                <li>Notify us immediately of any changes to your contact information</li>
                <li>Use your trademark in commerce as required by law</li>
                <li>Maintain accurate records of trademark use</li>
              </ul>
            </div>

            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">5. No Guarantee of Registration</h2>
              <p className="text-gray-700 leading-relaxed">
                While we strive to provide excellent service, we cannot guarantee that your trademark application will be approved by the USPTO. Approval depends on many factors including trademark availability, distinctiveness, and compliance with USPTO requirements. The final decision rests with the USPTO.
              </p>
            </div>

            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">6. Refund Policy</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Our refund policy is as follows:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                <li>Service fees may be refunded if requested before we begin work on your application</li>
                <li>Once work has commenced, service fees are non-refundable</li>
                <li>Government filing fees are non-refundable in all circumstances</li>
                <li>Refund requests must be submitted in writing to info@globaltrademarkpro.com</li>
              </ul>
            </div>

            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">7. Intellectual Property</h2>
              <p className="text-gray-700 leading-relaxed">
                All content on our website, including text, graphics, logos, and software, is the property of Global Trademark Pro and is protected by copyright and trademark laws. You may not use, reproduce, or distribute our content without written permission.
              </p>
            </div>

            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">8. Limitation of Liability</h2>
              <p className="text-gray-700 leading-relaxed">
                Global Trademark Pro shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or related to your use of our services. Our total liability shall not exceed the amount paid by you for our services.
              </p>
            </div>

            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">9. Confidentiality</h2>
              <p className="text-gray-700 leading-relaxed">
                We maintain strict confidentiality of all client information. However, please note that trademark applications become public record once filed with the USPTO.
              </p>
            </div>

            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">10. Termination</h2>
              <p className="text-gray-700 leading-relaxed">
                Either party may terminate the service agreement with written notice. Upon termination, you remain responsible for all fees incurred up to the termination date.
              </p>
            </div>

            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">11. Governing Law</h2>
              <p className="text-gray-700 leading-relaxed">
                These Terms and Conditions are governed by and construed in accordance with the laws of the State of New York, without regard to its conflict of law provisions.
              </p>
            </div>

            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">12. Changes to Terms</h2>
              <p className="text-gray-700 leading-relaxed">
                We reserve the right to modify these Terms and Conditions at any time. Changes will be effective immediately upon posting to our website. Your continued use of our services constitutes acceptance of the modified terms.
              </p>
            </div>

            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">13. Contact Information</h2>
              <p className="text-gray-700 leading-relaxed">
                If you have any questions about these Terms and Conditions, please contact us:
              </p>
              <div className="mt-4 p-6 bg-gradient-to-br from-emerald-50 to-blue-50 rounded-xl">
                <p className="text-gray-700"><strong>Global Trademark Pro</strong></p>
                <p className="text-gray-700">Email: info@globaltrademarkpro.com</p>
                <p className="text-gray-700">Phone: +1 (888) 909 9199</p>
                <p className="text-gray-700">Address: 714 E Carson St, Carson, CA 90745, United States</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsConditions;